// index.js — app entry point
//
// react-native-track-player requires its playback service to be registered
// before the React component tree mounts. We do that here, then hand off to
// the standard Expo root registration.
//
// The service runs in a separate background thread on Android and handles
// remote-command events (lock-screen play/pause/stop) even when the JS thread
// is suspended. On iOS it handles MPRemoteCommandCenter callbacks.
//
// See: https://rntp.dev/docs/basics/playback-service

import TrackPlayer from 'react-native-track-player';
import { registerRootComponent } from 'expo';
import { PlaybackService } from './src/audio/TrackPlayerService';
import App from './App';

// Register the background service BEFORE mounting the React tree.
TrackPlayer.registerPlaybackService(() => PlaybackService);

registerRootComponent(App);
